import { transparentize } from "color2k";

/**
 * Converts a color string to RGBA format.
 * @param color The color string to convert.
 * @param opacity The transparency value to apply to the color.
 * @example
 * // returns rgba(0, 0, 0, 0.5)
 * convertToRgba('#000', 0.5);
 */
export function convertToRgba(color: string, opacity: number) {
  return transparentize(color, 1 - opacity);
}
